<template>
  <div class="station-list" id="station-list">
    <!-- <div>
        <input id="address" type="textbox" value="北京市海淀区彩和坊路海淀西大街74号">
        <button @click="codeAddress()">search</button>
    </div> -->
    <div
      style="width: 603px; height: 300px; display: none"
      id="container"
    ></div>
    <div class="station-list-top">
      <span>场站列表</span>
      <div class="station-select">
        <el-select
          v-model="provincesName"
          clearable
          placeholder="请选择省"
          @change="provincesChange"
        >
          <el-option
            v-for="item in provincesList"
            :key="item.province"
            :label="item.province"
            :value="item.province"
          ></el-option>
        </el-select>
        <el-select
          v-model="cityName"
          clearable
          placeholder="请选择市"
          @change="cityChange"
        >
          <el-option
            v-for="item in cityList"
            :key="item.city"
            :label="item.city"
            :value="item.city"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="station-list-table">
      <div class="station-list-button">
        <el-button
          @click="newTemplateClick(1)"
          :disabled="addPrivilege == 1"
          :class="[addPrivilege == 1 ? 'active' : '']"
          >新建场站 +</el-button
        >
      </div>
      <div class="table-list">
        <el-table
          :data="yemiandata"
          :header-cell-style="{
            background: '#f3f3f3',
            color: '#323232',
            height: '50px',
          }"
          border
          style="width: 100%"
        >
          <el-table-column prop="station_name" label="场站名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="station_id" label="场站编号" width>
          </el-table-column>
          <el-table-column prop="operation_mode" label="运营类型">
            <template slot-scope="scope">
              <span v-if="scope.row.operation_mode == 1">联营</span>
              <span v-else-if="scope.row.operation_mode == 2">直营</span>
              <span v-else-if="scope.row.operation_mode == 3">加盟</span>
              <span v-else-if="scope.row.operation_mode == 4">托管</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="station_type" label="场站类型" width>
            <template slot-scope="scope">
              <span v-if="scope.row.station_type == 1">充电站</span>
              <span v-else-if="scope.row.station_type == 2">可预约充电</span>
              <span v-else-if="scope.row.station_type == 3">停车场</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="visibility" label="开放类型" width>
            <template slot-scope="scope">
              <span v-if="scope.row.visibility == 1">可见</span>
              <span v-else-if="scope.row.visibility == 2">不可见</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="province" label="省份">
            <template slot-scope="scope">{{
              scope.row.province | defaultValFilter
            }}</template>
          </el-table-column>
          <el-table-column prop="city" label="城市" width>
            <template slot-scope="scope">{{
              scope.row.city | defaultValFilter
            }}</template>
          </el-table-column>
          <el-table-column prop="zone1" label="区/县" width>
            <template slot-scope="scope">{{
              scope.row.zone1 | defaultValFilter
            }}</template>
          </el-table-column>
          <el-table-column prop="zone2" label="街道">
            <template slot-scope="scope">{{
              scope.row.zone2 | defaultValFilter
            }}</template>
          </el-table-column>
          <el-table-column prop="enterprise_name" label="运营商" show-overflow-tooltip>
            <template slot-scope="scope">{{
              scope.row.enterprise_name | defaultValFilter
            }}</template>
          </el-table-column>
          <el-table-column prop="longitude" label="经度" width>
            <template slot-scope="scope">{{
              scope.row.longitude | defaultValFilter
            }}</template>
          </el-table-column>
          <el-table-column prop="latitude" label="纬度">
            <template slot-scope="scope">{{
              scope.row.latitude | defaultValFilter
            }}</template>
          </el-table-column>
          <el-table-column prop="start_time" label="营业开始时间" width>
            <template slot-scope="scope">{{
              scope.row.start_time | defaultValFilter
            }}</template>
          </el-table-column>
          <el-table-column prop="end_time" label="营业结束时间" width>
            <template slot-scope="scope">{{
              scope.row.end_time | defaultValFilter
            }}</template>
          </el-table-column>
          <el-table-column width="270" label="操作">
            <template slot-scope="scope">
              <el-button class="btn details" @click="detailsClick(scope.row, 3)"
                >详情</el-button
              >
              <el-button
                class="btn edit"
                @click="editClick(scope.row, 2)"
                :disabled="editPrivilege == 1"
                :class="[editPrivilege == 1 ? 'active' : '']"
                >编辑</el-button
              >
              <el-button
                class="btn delete"
                @click="deleteClick(scope.row)"
                :disabled="deletePrivilege == 1"
                :class="[deletePrivilege == 1 ? 'active' : '']"
                >删除</el-button
              >
              <el-button
                class="btn img"
                @click="getImg(scope.row)"
                :disabled="seeImgPrivilege == 1"
                :class="[seeImgPrivilege == 1 ? 'active' : '']"
                >图片</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="currentChange"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新建场站 -->
    <el-dialog
      :visible.sync="newStationDialog"
      customClass="new-station-dialog"
      width="934px"
      @close="cancelClick"
      :close-on-click-modal="false"
    >
      <p class="title">{{ templateTitle }}</p>
      <div class="line"></div>
      <div class="new-station-parameter">
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">场站名称：</span>
          <el-input
            v-model="nameOfStation"
            :disabled="detailsDisabeld == true"
            maxlength="50"
            clearable
            placeholder="请输入场站名称"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">场站编号：</span>
          <el-input
            :disabled="disabled == true || detailsDisabeld == true"
            maxlength="20"
            clearable
            v-model="stationNumber"
            placeholder="唯一，不多于20位数字。一旦保存不可修改"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">所属企业：</span>
          <el-select
            v-model="affiliatedEnterprises"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请选择所属企业"
          >
            <el-option
              v-for="item in affiliatedEnterprisesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">运营商ID：</span>
          <el-input
            :disabled="true"
            maxlength="20"
            v-model="operator_id"
          ></el-input>
        </div>
        <div class="parameter" style="width: 80%">
          <span class="star" style="margin-left: -68px">*</span>
          <span class="name">设备所属方ID：</span>
          <el-input
            v-model="equipment_own_id"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="9"
            placeholder="请输入运营商ID"
            style="width: 70%"
          ></el-input>
          <el-tooltip placement="left-start">
            <div slot="content" style="line-height: 26px; font-size: 16px">
              运营商ID使用组织机构代码（去掉“-”符号的9位字符，<br />对于新营业执照（三码合一）其组织机构代码为社会信用<br />代码去掉前八位和最后一位后的中间的数字）
            </div>
            <span class="tool-tip">?</span>
          </el-tooltip>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">场站类型：</span>
          <el-select
            v-model="stationType"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请选择场站类型"
          >
            <el-option
              v-for="item in stationTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">运营类型：</span>
          <el-select
            v-model="operationModeName"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请选择运营类型"
          >
            <el-option
              v-for="item in operationModeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">站点类型：</span>
          <el-select
            v-model="station_use_type"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请选择站点类型"
          >
            <el-option
              v-for="item in stationUseTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">是否公开：</span>
          <el-select
            v-model="visibility"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请选择是否公开"
          >
            <el-option
              v-for="item in visibilityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="parameter parameter-city">
          <span class="star">*</span>
          <span class="name">所属省市区：</span>
          <el-select
            v-model="provinceNameTem"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请选择省份"
            @change="provinceChanged"
          >
            <el-option
              v-for="item in provinceNameTemList"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="cityNameTem"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请选择城市"
            @change="cityChanged"
          >
            <el-option
              v-for="item in cityNameTemList"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="parameter parameter-city">
          <span class="star ml-13">*</span>
          <span class="name">所属区域：</span>
          <!-- <el-input v-model="area" clearable placeholder="请填写区/县"></el-input> -->
          <el-select
            v-model="areaNameTem"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请选择区/县"
            @change="areaChanged"
          >
            <el-option
              v-for="item in areaNameTemList"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            v-model="street"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请填写详细街道"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-40">*</span>
          <span class="name">地址：</span>
          <el-input
            v-model="address"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="500"
            placeholder="请输入地址"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-40">*</span>
          <span class="name">经度：</span>
          <el-input
            v-model="longitude"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请输入经度"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-40">*</span>
          <span class="name">纬度：</span>
          <el-input
            v-model="latitude"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请输入纬度"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">站点状态：</span>
          <el-select
            v-model="stationStatus"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请选择站点状态"
          >
            <el-option
              v-for="item in stationStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">建设场所：</span>
          <el-select
            v-model="station_around"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请选择建设场所"
          >
            <el-option
              v-for="item in constructionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="parameter parameter-city">
          <span class="star" style="margin-left: 14px">*</span>
          <span class="name">营业时间：</span>
          <!-- <el-input v-model="startTime" :disabled="detailsDisabeld==true" maxlength="100" clearable placeholder="请填写营业开始时间"></el-input> -->
          <!-- <el-input v-model="endTime" :disabled="detailsDisabeld==true" maxlength="100" clearable placeholder="请填写营业结束时间"></el-input> -->
          <!-- <el-time-picker
            :disabled="detailsDisabeld == true"
            v-model="startTime"
            value-format="HH:mm:ss"
            format="HH:mm:ss"
            :picker-options="{
              
            }"
            placeholder="请填写营业开始时间"
          >
          </el-time-picker>
          <el-time-picker
            :disabled="detailsDisabeld == true"
            v-model="endTime"
            value-format="HH:mm:ss"
            format="HH:mm:ss"
            :picker-options="{
              selectableRange: '00:00:00 - 23:00:00'
            }"
            placeholder="请填写营业结束时间"
          >
          </el-time-picker> -->
          <el-select
            v-model="startTime"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请填写营业开始时间"
          >
            <el-option
              v-for="item in timeList"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="endTime"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请填写营业结束时间"
          >
            <el-option
              v-for="item in timeList"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="parameter">
          <span class="star" style="margin-left: -27px">*</span>
          <span class="name">充电站国家代码：</span>
          <el-input
            v-model="county_code"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="默认中国填写CN"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">服务电话：</span>
          <el-input
            v-model="service_phone"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="30"
            placeholder="请输入服务电话"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-24"></span>
          <span class="name">站点电话：</span>
          <el-input
            v-model="station_phone"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="30"
            placeholder="请输入站点电话"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">站点引导：</span>
          <el-input
            v-model="station_guide"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="100"
            placeholder="请输入站点引导"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">车位数量：</span>
          <el-input
            v-model="park_num"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请输入车位数量"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="name" style="margin-left: 21px">车型描述：</span>
          <el-input
            v-model="car_match"
            maxlength="100"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请输入车型描述"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star" style="margin-left: -46px"></span>
          <span class="name">车位楼层及数量描述：</span>
          <el-input
            v-model="park_info"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="100"
            placeholder="请输入车位楼层及数量描述"
          ></el-input>
        </div>

        <!-- <div class="parameter">
                <span class="star" style="margin-left:11px;"></span>
                <span class="name">充电电费率：</span>
                <el-input v-model="electric_fee" :disabled="detailsDisabeld==true" clearable maxlength="256" placeholder="请输入充电电费率"></el-input>
            </div>
            <div class="parameter">
                <span class="star" style="margin-left:28px;"></span>
                <span class="name">服务费率：</span>
                <el-input v-model="service_fee" :disabled="detailsDisabeld==true" clearable maxlength="100" placeholder="请输入服务费率"></el-input>
            </div> -->

        <div class="parameter">
          <span class="star" style="margin-left: 43px"></span>
          <span class="name">停车费：</span>
          <el-input
            v-model="park_fee"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="100"
            placeholder="请输入停车费"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star" style="margin-left: 32px"></span>
          <span class="name">支付方式：</span>
          <el-input
            v-model="payment"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="20"
            placeholder="请输入支付方式"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star" style="margin-left: 5px"></span>
          <span class="name">是否支持预约：</span>
          <el-select
            v-model="support_order"
            :disabled="detailsDisabeld == true"
            clearable
            placeholder="请选择是否支持预约"
          >
            <el-option
              v-for="item in supportOrderList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="parameter">
          <span class="star" style="margin-left: 63px"></span>
          <span class="name">备注：</span>
          <el-input
            v-model="remark"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="100"
            placeholder="请输入备注"
          ></el-input>
        </div>
        <!-- 停车场编号输入框 -->
        <div class="parameter">
          <span class="star" style="margin-left: 15px"></span>
          <span class="name">停车场编号：</span>
          <el-input
            :value="getInputValue(parkingLotNumber)"
            @input="parkingLotNumber = $event"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="100"
            placeholder="请输入停车场编号"
          ></el-input>
        </div>

         <!-- 道闸系统套餐输入框 -->
         <div class="parameter">
          <span class="star" style="margin-left: 5px"></span>
          <span class="name">道闸系统套餐：</span>
          <el-input
            :value="getInputValue(abilityCode)"
            @input="abilityCode = $event"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="100"
            placeholder="请输入道闸系统套餐"
          ></el-input>
        </div>
        <!-- 道闸APPID输入框 -->
        <div class="parameter">
          <span class="star" style="margin-left: 5px"></span>
          <span class="name">道闸APPID：</span>
          <el-input
            :value="getInputValue(parking_app_id)"
            @input="parking_app_id = $event"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="100"
            placeholder="请输入道闸APPID"
          ></el-input>
        </div>
        <!-- 道闸APP Secret输入框 -->
        <div class="parameter">
          <span class="star" style="margin-left: -20px"></span>
          <span class="name">道闸APPSecret：</span>
          <el-input
            :value="getInputValue(parking_app_secret)"
            @input="parking_app_secret = $event"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="1000"
            placeholder="请输入道闸APP Secret"
          ></el-input>
        </div>
        <!-- 打折商户名输入框 -->
        <div class="parameter">
          <span class="star" style="margin-left: 5px"></span>
          <span class="name">打折商户名：</span>
          <el-input
            :value="getInputValue(discountMerchantName)"
            @input="discountMerchantName = $event"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="100"
            placeholder="请输入打折商户名"
          ></el-input>
        </div>
        <!-- 商户号输入框 -->
        <div class="parameter">
          <span class="star" style="margin-left: 15px"></span>
          <span class="name">商户号：</span>
          <el-input
            :value="getInputValue(cid)"
            @input="cid = $event"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="100"
            placeholder="请输入商户号"
          ></el-input>
        </div>
        <!-- 折扣名称输入框 -->
        <div class="parameter">
          <span class="star" style="margin-left: 5px"></span>
          <span class="name">折扣名称：</span>
          <el-input
            :value="getInputValue(discountName)"
            @input="discountName = $event"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="100"
            placeholder="请输入折扣名称"
          ></el-input>
        </div>
        <!-- 折扣模版编码输入框 -->
        <div class="parameter">
          <span class="star" style="margin-left: -15px"></span>
          <span class="name">折扣模版编码：</span>
          <el-input
            :value="getInputValue(discountTemplateCode)"
            @input="discountTemplateCode = $event"
            :disabled="detailsDisabeld == true"
            clearable
            maxlength="100"
            placeholder="请输入折扣模版编码"
          ></el-input>
        </div>
        <!-- 折扣方式选择框 -->
        <div class="parameter">
          <span class="star" style="margin-left: 5px"></span>
          <span class="name">折扣方式：</span>
          <el-select
            v-model="discountMethod"
            :disabled="detailsDisabeld"
            clearable
            placeholder="请选择折扣方式：0 按折扣金额，1 按折扣时长，2 按折扣比例"
          >
            <el-option label="按折扣金额" value="0"></el-option>
            <el-option label="按折扣时长" value="1"></el-option>
            <el-option label="按折扣比例" value="2"></el-option>
          </el-select>
        </div>
        <!-- 根据折扣方式动态显示对应的输入框 -->
        <!-- 按折扣时长输入框 -->
        <div class="parameter" v-if="discountMethod === '1'">
          <span class="star" style="margin-left: 5px"></span>
          <span class="name">按折扣时长：</span>
          <el-input
            :value="getInputValue(discountDuration)"
            @input="discountDuration = $event"
            :disabled="detailsDisabeld"
            clearable
            maxlength="100"
            placeholder="请输入按折扣时长(单位分)"
          ></el-input>
        </div>
        <!-- 按折扣金额输入框 -->
        <div class="parameter" v-if="discountMethod === '0'">
          <span class="star" style="margin-left: 5px"></span>
          <span class="name">按折扣金额：</span>
          <el-input
            :value="getInputValue(discountAmount)"
            @input="discountAmount = $event"
            :disabled="detailsDisabeld"
            clearable
            maxlength="100"
            placeholder="按折扣金额(单位元)"
          ></el-input>
        </div>
        <!-- 按折扣比例输入框 -->
        <div class="parameter" v-if="discountMethod === '2'">
          <span class="star" style="margin-left: 5px"></span>
          <span class="name">按折扣比例：</span>
          <el-input
            :value="getInputValue(discountRate)"
            @input="discountRate = $event"
            :disabled="detailsDisabeld"
            clearable
            maxlength="100"
            placeholder="请输入按折扣比例(1 - 10)"
          ></el-input>
        </div>
        <div class="parameter-btn" v-if="detailsDisabeld == false">
          <el-button class="cancel" @click="cancelClick">取消</el-button>
          <el-button class="confirm" @click="confirmClick">确认</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 选择场站图片 -->
    <el-dialog
      :visible.sync="imgDialog"
      customClass="select-img-dialog"
      width="934px"
    >
      <p class="title">选择场站图片</p>
      <div class="line"></div>
      <div class="img-box">
        <div class="img-list">
          <div class="img" v-for="(item, index) in imgList" :key="index">
            <img :src="item" alt="" />
            <div>
              <span></span>
              <i @click="deleteImg(item)"></i>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="upload-btn">
          <div class="upload-left">
            <input type="text" v-model="fileName" placeholder="请选择文件" />
            <el-upload
              class="upload-demo"
              :action="global"
              :headers="headers"
              :show-file-list="false"
              :auto-upload="false"
              ref="upload"
              :data="resData"
              :on-change="imgBroadcastChange"
              :onSuccess="uploadSuccess"
            >
              <el-button size="small" type="primary" class="file-btn"
                ><i class="file-icon"></i
              ></el-button>
            </el-upload>
          </div>
          <div class="upload-rig">
            <el-button @click="startUpload()">开始上传</el-button>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import provinceCity from "./proviceCityArea.json";
import $axios from "axios";
import Bus from "../../assets/js/bus.js";
//import { uploadImgToBase64 } from '../../assets/js/utils' // 导入本地图片转base64的方法
import { constants } from "fs";
import { connect } from "tls";
import { debug } from "util";
export default {
  name: "provinceCity",
  props: {
    provinceCode: {
      type: String,
      default: "",
    },
    cityCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      operator_id: "MA5FB6W50",
      timeList: [],
      imgPath: "",
      tableData: [],
      // 页面需要展现的数据
      yemiandata: [],
      // 页面展现条数
      datanum: 14,
      // 开始页数
      startnum: 0,
      // 结束页数
      endnum: 1,
      // 一共多少页
      totalNum: 0,
      provincesList: [],
      provincesName: "",
      cityList: [],
      cityName: "",
      stationList: [],
      stationName: "",
      stationId: "",
      newStationDialog: false,
      templateTitle: "新建场站",
      nameOfStation: "", //场站名称
      stationNumber: "", //场站编号
      affiliatedEnterprises: "", //所属企业
      affiliatedEnterprisesList: [], //所属企业list
      stationType: "",
      stationTypeList: [
        {
          value: "1",
          label: "充电站",
        },
        {
          value: "2",
          label: "可预约充电",
        },
        {
          value: "3",
          label: "停车场",
        },
      ], //场站类型
      visibility: "",
      visibilityList: [
        {
          value: "1",
          label: "可见",
        },
        {
          value: "2",
          label: "不可见",
        },
      ], //是否公开
      operationModeList: [
        {
          value: "1",
          label: "联营",
        },
        {
          value: "2",
          label: "直营",
        },
        {
          value: "3",
          label: "加盟",
        },
        {
          value: "4",
          label: "托管",
        },
      ],
      operationModeName: "",
      cityNameTem: "", //市
      provinceNameTem: "", //省
      cityNameTemList: [], //市
      provinceNameTemList: [], //省
      areaNameTemList: [],
      areaNameTem: "",
      area: "", //区
      street: "", //街道
      address: "",
      latitude: "", //纬度
      longitude: "", //经度
      startTime: "00:00:00",
      endTime: "24:00:00",
      editStationId: "",
      num: "",
      station: {},
      disabled: false,
      imgList: [],
      imgDialog: false,
      fileList: [],
      editForm: {
        goodsImg: "",
        imgName: "",
      },
      resData: {},
      imgStationId: "",
      headers: {},
      file: {},
      global: "https://service-web.szdreamerstech.com//api.php/DeviceManage/index",
      fileName: "",
      message: false,
      clientWidth: "",
      addPrivilege: 1, //新建
      editPrivilege: 1, //编辑
      seeImgPrivilege: 1, //查看图片
      deletePrivilege: 1, //删除
      //   互联互通
      area_code: "",
      station_use_type: "", //站点类型
      stationUseTypeList: [
        {
          value: "1",
          label: "公共",
        },
        {
          value: "50",
          label: "个人",
        },
        {
          value: "100",
          label: "公交（专用）",
        },
        {
          value: "101",
          label: "环卫（专用）",
        },
        {
          value: "102",
          label: "物流（专用）",
        },
        {
          value: "103",
          label: "出租车（专用）",
        },
        {
          value: "201",
          label: "企业单位（专用）",
        },
        {
          value: "202",
          label: "事业单位（专用）",
        },
        {
          value: "203",
          label: "限制级公用",
        },
        {
          value: "255",
          label: "其他",
        },
      ],
      stationStatusList: [
        {
          value: "0",
          label: "未知",
        },
        {
          value: "1",
          label: "建设中",
        },
        {
          value: "5",
          label: "关闭下线",
        },
        {
          value: "6",
          label: "维护中",
        },
        {
          value: "50",
          label: "正常使用",
        },
      ],
      stationStatus: "",
      constructionList: [
        {
          value: "1",
          label: "居民区",
        },
        {
          value: "2",
          label: "公共机构",
        },
        {
          value: "3",
          label: "企事业单位",
        },
        {
          value: "4",
          label: "写字楼",
        },
        {
          value: "5",
          label: "工业园区",
        },
        {
          value: "6",
          label: "交通枢纽",
        },
        {
          value: "7",
          label: "大型文体设施",
        },
        {
          value: "8",
          label: "城市绿地",
        },
        {
          value: "9",
          label: "大型建筑配建停车场",
        },
        {
          value: "10",
          label: "路边停车位",
        },
        {
          value: "11",
          label: "城际高速服务区",
        },
        {
          value: "255",
          label: "其他",
        },
      ],
      station_around: "",
      supportOrderList: [
        {
          value: "0",
          label: "不支持预约",
        },
        {
          value: "1",
          label: "支持预约",
        },
      ],
      support_order: "",
      equipment_own_id: "",
      county_code: "",
      station_phone: "",
      service_phone: "",
      park_num: "",
      station_guide: "",
      park_info: "",
      electric_fee: "",
      service_fee: "",
      park_fee: "",
      payment: "",
      remark: "",
      parkingLotNumber: "", // 停车场编号
      abilityCode: "", // 道闸系统套餐
      parking_app_id: "",
      parking_app_secret: "",
      discountMerchantName: "",
      cid: "",
      discountName: "",
      discountTemplateCode: "",
      discountMethod: "",
      discountDuration: "",
      discountAmount: "",
      discountRate: "",
      detailsDisabeld: false,
      car_match: "",
    };
  },
  computed: {
    isChangeMsg() {
      //  console.log(this.$store.state.collapse);
      return this.$store.state.collapse;
    },
     // 计算属性，判断值是否为空字符串、null 或 0
     getInputValue() {
      return (value) => {
        if (value === "" || value === null || value === "null" || value === "0") {
          return "";
        }
        return value;
      };
    },
  },
  mounted() {
    this.$nextTick(function () {
      let role = [];
      role = this.$store.state.role;
      for (let i in role) {
        if (role[i].view_name == "场站管理") {
          for (let j in role[i].chlid) {
            if (role[i].chlid[j].view_name == "场站列表") {
              for (let m in role[i].chlid[j].method) {
                if (role[i].chlid[j].method[m].method_name == "新建场站") {
                  this.addPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "查看图片"
                ) {
                  this.seeImgPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "删除场站"
                ) {
                  this.deletePrivilege = 0;
                } else if (role[i].chlid[j].method[m].method_name == "编辑") {
                  this.editPrivilege = 0;
                }
              }
            }
          }
        }
      }
      this.getTimeList();
      this.getProvinces();
      this.getDataList();
      this.provinceNameTem = this.provinceCode;
      this.provinceChanged(this.provinceNameTem);
      this.cityNameTem = this.cityCode;
    });
  },
  destroyed() {
    window.onresize = null;
  },
  watch: {
    isChangeMsg(val) {
      // debugger
      this.message = val;
    },
  },
  created() {
    this.provinceNameTemList = provinceCity.provinces;
  },
  beforeRouteEnter(to, from, next) {
    window.document
      .querySelector("body")
      .setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#EFEFEF";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  methods: {
    getTimeList() {
      for (var i = 0; i <= 24; i++) {
        if (i < 10) {
          this.timeList.push({ value: "0" + i + ":00:00" });
        } else {
          this.timeList.push({ value: i + ":00:00" });
        }
      }
    },
    codeAddress() {
      var address = document.getElementById("address").value;
      var geocoder = null;
      // console.log(address);
      //地址和经纬度之间进行转换服务
      geocoder = new qq.maps.Geocoder();
      //设置服务请求成功的回调函数
      geocoder.setComplete(function (result) {
        // console.log(result.detail.location);
      });
      //若服务请求失败，则运行以下函数
      geocoder.setError(function () {
        // console.log("出错了，请输入正确的地址！！！");
      });
      //对指定地址进行解析
      geocoder.getLocation(address);
    },
    provinceChanged(value) {
      // debugger
      if (value !== "") {
        for (let item of this.provinceNameTemList) {
          if (item.value === value) {
            this.cityNameTemList = item.children;
            this.cityNameTem = "";
            this.areaNameTemList = [];
            this.areaNameTem = "";
            break;
          } else {
            continue;
          }
        }
      } else {
        this.cityNameTemList = [];
        this.cityNameTem = "";
        this.areaNameTemList = [];
        this.areaNameTem = "";
      }
      this.$emit("selectChange", this.provinceNameTem, this.cityNameTem);
    },
    cityChanged(value) {
      if (value !== "") {
        for (let item of this.cityNameTemList) {
          if (item.value == value) {
            this.areaNameTemList = item.children;
            this.areaNameTem = "";
            break;
          } else {
            continue;
          }
        }
      } else {
        this.areaNameTemList = [];
        this.areaNameTem = "";
      }
      this.$emit("selectChange", this.provinceNameTem, this.cityNameTem);
    },
    areaChanged(value) {
      //   this.areaNameTem = value;
      for (let i in this.areaNameTemList) {
        if (this.areaNameTemList[i].value == value) {
          this.area_code = this.areaNameTemList[i].label;
        }
      }
      console.log(this.area_code);
      // let address = this.provinceNameTem + this.cityNameTem + this.areaNameTem;
      // let geocoder = null;
      // let _self = this;
      // // console.log(address);
      // //地址和经纬度之间进行转换服务
      // geocoder = new qq.maps.Geocoder();
      // //设置服务请求成功的回调函数
      // geocoder.setComplete(function (result) {
      //   // console.log(result.detail.location);
      //   _self.longitude = result.detail.location.lng;
      //   _self.latitude = result.detail.location.lat;
      // });
      // //若服务请求失败，则运行以下函数
      // geocoder.setError(function () {
      //   // console.log("出错了，请输入正确的地址！！！");
      // });
      // //对指定地址进行解析
      // geocoder.getLocation(address);
    },
    resetProviceCity(province, city) {
      this.cities = [];
      if (province && city) {
        this.provinceNameTem = province;
        this.provinceChanged(this.provinceNameTem);
        this.cityNameTem = city;
      } else {
        this.provinceNameTem = "";
        this.cityNameTem = "";
      }
    },
    handleSizeChange(data) {
      // debugger
    },
    currentChange(data) {
      this.endnum = data;
      this.startnum = data - 1;
      this.yemiandata = this.tableData.slice(
        this.startnum * this.datanum,
        this.endnum * this.datanum
      );
    },
    getProvinces() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.provincesList = su.data.list;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    provincesChange(province) {
      this.cityName = "";
      this.cityList = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.cityList = su.data.list;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    cityChange(city) {
      this.totalNum = 0;
      this.startnum = 0;
      this.endnum = 1;
      this.getDataList(this.provincesName, this.cityName);
      // this.stationList = [];
      // this.stationName = "";
      // let params = {
      //     uid: localStorage.getItem("uid"),
      //     token: localStorage.getItem("token"),
      //     city:city,
      // };
      // this.$api({
      //     method: "post",
      //     url: "/api.php/Currency/get_stations",
      //     data: params,
      //     transformRequest: [
      //     data => {
      //         let ret = "";
      //         for (let it in data) {
      //         ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
      //         }
      //         return ret;
      //     }
      //     ]
      // })
      //     .then(su => {
      //         if(su.data.code == 1){
      //             this.stationList = su.data.list;
      //         } else if(su.data.code == 300) {
      //             this.$router.push('/login');
      //             this.$message.warning(su.data.message);
      //         } else {
      //             this.$message.warning(su.data.message);
      //         }
      //     })
      //     .catch(err => {
      // });
    },
    stationChange(stationId) {
      // debugger
      // this.getDataList(this.provincesName,this.cityName,this.stationName);
      this.getDataList(this.provincesName, this.cityName);
    },
    getDataList(provincesName, cityName) {
      this.headers = {
        "Content-Type": "multipart/form-data",
      };
      if (provincesName == undefined) {
        provincesName = "";
      }
      if (cityName == undefined) {
        cityName = "";
      }

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getStationList",
        province: provincesName,
        city: cityName,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.tableData = su.data.list;
            this.totalNum = this.tableData.length;
            if (this.totalNum > 10) {
              this.yemiandata = this.tableData.slice(
                this.startnum * this.datanum,
                this.endnum * this.datanum
              );
            } else {
              this.yemiandata = this.tableData;
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    newTemplateClick(num) {
      this.templateTitle = "新建场站";
      this.newStationDialog = true;
      this.getEnterprises();
      this.num = num;
      this.disabled = false;
      this.cityNameTemList = [];
      this.areaNameTemList = [];
    },
    editClick(row, num) {
      this.templateTitle = "编辑场站";
      this.newStationDialog = true;
      // debugger
      this.disabled = true;
      this.editStationId = row.station_id;
      this.num = num;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getStationDetail",
        station_id: this.editStationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.affiliatedEnterprisesList = su.data.enterprises;
            this.station = su.data.station;
            this.nameOfStation = this.station.station_name;
            this.stationNumber = this.station.station_id;
            this.affiliatedEnterprises = this.station.enterprise_id;
            this.stationType = this.station.station_type;
            this.operationModeName = this.station.operation_mode;
            this.visibility = this.station.visibility;
            this.cityNameTem = this.station.city;
            this.provinceNameTem = this.station.province;
            this.areaNameTem = this.station.zone1;
            this.street = this.station.zone2;
            this.address = this.station.address;
            this.latitude = this.station.latitude;
            this.longitude = this.station.longitude;
            this.startTime = this.station.start_time;
            this.endTime = this.station.end_time;
            this.provinceChangedEdit(this.provinceNameTem);

            this.area_code = this.station.area_code;
            this.equipment_own_id = this.station.equipment_own_id;
            this.county_code = this.station.county_code;
            this.station_phone = this.station.station_phone;
            this.service_phone = this.station.service_phone;
            this.stationStatus = this.station.station_status;
            this.park_num = this.station.park_num;
            this.car_match = this.station.car_match;
            this.station_guide = this.station.station_guide;
            this.station_around = this.station.station_around;
            this.park_info = this.station.park_info;
            // this.electric_fee = this.station.electric_fee;
            // this.service_fee = this.station.service_fee;
            this.park_fee = this.station.park_fee;
            this.payment = this.station.payment;
            this.support_order = this.station.support_order;
            this.remark = this.station.remark;
            this.parkingLotNumber = this.station.parking_id;
            this.abilityCode = this.station.ability_code;
            this.station_use_type = this.station.station_use_type;
            this.parking_app_id = this.station.parking_app_id;
            this.parking_app_secret = this.station.parking_app_secret;
            this.discountMerchantName = this.station.parking_discount_client_name;
            this.cid = this.station.cid;
            this.discountName = this.station.parking_proj_name;
            this.discountTemplateCode = this.station.parking_proj_code;
            this.discountMethod = this.station.parking_discount_method;
            this.discountDuration = this.station.parking_discount_time;
            this.discountAmount = this.station.parking_discount_money;
            this.discountRate = this.station.parking_discount_ratio;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    detailsClick(row, data) {
      // debugger
      this.templateTitle = "场站详情";
      this.newStationDialog = true;
      // debugger
      this.disabled = true;
      this.detailsDisabeld = true;
      // this.editStationId = row.station_id;
      // this.num = num;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getStationDetail",
        station_id: row.station_id,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.affiliatedEnterprisesList = su.data.enterprises;
            this.station = su.data.station;
            this.nameOfStation = this.station.station_name;
            this.stationNumber = this.station.station_id;
            this.affiliatedEnterprises = this.station.enterprise_id;
            this.stationType = this.station.station_type;
            this.operationModeName = this.station.operation_mode;
            this.visibility = this.station.visibility;
            this.cityNameTem = this.station.city;
            this.provinceNameTem = this.station.province;
            this.areaNameTem = this.station.zone1;
            this.street = this.station.zone2;
            this.address = this.station.address;
            this.latitude = this.station.latitude;
            this.longitude = this.station.longitude;
            this.startTime = this.station.start_time;
            this.endTime = this.station.end_time;
            this.provinceChangedEdit(this.provinceNameTem);

            // this.area_code = this.station.area_code;
            this.equipment_own_id = this.station.equipment_own_id;
            this.county_code = this.station.county_code;
            this.station_phone = this.station.station_phone;
            this.service_phone = this.station.service_phone;
            this.stationStatus = this.station.station_status;
            this.park_num = this.station.park_num;
            this.car_match = this.station.car_match;
            this.station_guide = this.station.station_guide;
            this.station_around = this.station.station_around;
            this.park_info = this.station.park_info;
            this.electric_fee = this.station.electric_fee;
            this.service_fee = this.station.service_fee;
            this.park_fee = this.station.park_fee;
            this.payment = this.station.payment;
            this.support_order = this.station.support_order;
            this.remark = this.station.remark;
            this.parkingLotNumber = this.station.parking_id;
            this.abilityCode = this.station.ability_code;
            this.station_use_type = this.station.station_use_type;
            this.parking_app_id = this.station.parking_app_id;
            this.parking_app_secret = this.station.parking_app_secret;
            this.discountMerchantName = this.station.parking_discount_client_name;
            this.cid = this.station.cid;
            this.discountName = this.station.parking_proj_name;
            this.discountTemplateCode = this.station.parking_proj_code;
            this.discountMethod = this.station.parking_discount_method;
            this.discountDuration = this.station.parking_discount_time;
            this.discountAmount = this.station.parking_discount_money;
            this.discountRate = this.station.parking_discount_ratio;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    provinceChangedEdit(value) {
      if (value !== "") {
        for (let item of this.provinceNameTemList) {
          if (item.value === value) {
            this.cityNameTemList = item.children;
            // this.cityNameTem = '';
            break;
          } else {
            continue;
          }
        }
      } else {
        // this.cityNameTemList = [];
        // this.cityNameTem = '';
        // this.areaNameTemList = [];
        // this.areaNameTem = '';
      }
      this.cityChangedEdit(this.cityNameTem);
    },
    cityChangedEdit(value) {
      if (value !== "") {
        for (let item of this.cityNameTemList) {
          if (item.value == value) {
            this.areaNameTemList = item.children;
            // this.areaNameTem = '';
            break;
          } else {
            continue;
          }
        }
      } else {
        // this.areaNameTemList = [];
        // this.areaNameTem = '';
      }
    },
    getEnterprises() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getEnterprises",
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.affiliatedEnterprisesList = su.data.list;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    cancelClick() {
      this.newStationDialog = false;
      this.nameOfStation = "";
      this.stationNumber = "";
      this.affiliatedEnterprises = "";
      this.stationType = "";
      this.operationModeName = "";
      this.visibility = "";
      this.cityNameTem = "";
      this.provinceNameTem = "";
      this.areaNameTem = "";
      this.street = "";
      this.address = "";
      this.latitude = "";
      this.longitude = "";
      this.startTime = "";
      this.endTime = "";
      this.editStationId = "";

      this.area_code = "";
      this.station_use_type = "";
      this.stationStatus = "";
      this.station_around = "";
      this.support_order = "";
      this.equipment_own_id = "";
      this.county_code = "";
      this.station_phone = "";
      this.service_phone = "";
      this.park_num = "";
      this.car_match = "";
      this.station_guide = "";
      this.park_info = "";
      // this.electric_fee = "";
      // this.service_fee = "";
      this.park_fee = "";
      this.payment = "";
      this.remark = "";
      this.parkingLotNumber = "";
      this.abilityCode = "";
      this.parking_app_id = "";
      this.parking_app_secret = "";
      this.discountMerchantName = "";
      this.cid = "";
      this.discountName = "";
      this.discountTemplateCode = "";
      this.discountMethod = "";
      this.discountDuration = "";
      this.discountAmount = "";
      this.discountRate = "";
      this.disabled = false;
      this.detailsDisabeld = false;
    },
    confirmClick() {
      // debugger
      var longrg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/;
      var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;
      if (isEmpty(this.nameOfStation)) {
        this.$message.warning("场站名称不能为空！");
        return;
      } else if (isEmpty(this.stationNumber)) {
        this.$message.warning("场站编号不能为空！");
        return;
      } else if (isEmpty(this.affiliatedEnterprises)) {
        this.$message.warning("所属企业不能为空！");
        return;
      } else if (isEmpty(this.equipment_own_id)) {
        this.$message.warning("设备所属方运营商ID不能为空！");
        return;
      } else if (isEmpty(this.stationType)) {
        this.$message.warning("请选择场站类型！");
        return;
      } else if (isEmpty(this.operationModeName)) {
        this.$message.warning("请选择运营类型！");
        return;
      } else if (isEmpty(this.station_use_type)) {
        this.$message.warning("请选择站点类型！");
        return;
      } else if (isEmpty(this.visibility)) {
        this.$message.warning("请选择是否公开！");
        return;
      } else if (isEmpty(this.provinceNameTem)) {
        this.$message.warning("请选择省份！");
        return;
      } else if (isEmpty(this.cityNameTem)) {
        this.$message.warning("请选择城市！");
        return;
      } else if (isEmpty(this.areaNameTem)) {
        this.$message.warning("请选择区域！");
        return;
      } else if (isEmpty(this.street)) {
        this.$message.warning("请输入详细街道！");
        return;
      } else if (isEmpty(this.address)) {
        this.$message.warning("请输入地址！");
        return;
      } else if (isEmpty(this.longitude)) {
        this.$message.warning("请输入经度！");
        return;
      } else if (!longrg.test(this.longitude)) {
        this.$message.warning("经度整数部分为0-180,小数部分为0到6位!");
        return;
      } else if (isEmpty(this.latitude)) {
        this.$message.warning("请输入纬度！");
        return;
      } else if (!latreg.test(this.latitude)) {
        this.$message.warning("纬度整数部分为0-90,小数部分为0到6位!");
        return;
      } else if (isEmpty(this.stationStatus)) {
        this.$message.warning("请选择站点状态！");
        return;
      } else if (isEmpty(this.station_around)) {
        this.$message.warning("请选择建设场所！");
        return;
      } else if (isEmpty(this.startTime)) {
        this.$message.warning("请填写营业开始时间！");
        return;
      } else if (isEmpty(this.endTime)) {
        this.$message.warning("请填写营业结束时间！");
        return;
      } else if (isEmpty(this.county_code)) {
        this.$message.warning("请输入充电站国家代码！");
        return;
      } else if (isEmpty(this.service_phone)) {
        this.$message.warning("请输入服务电话！");
        return;
      } else if (isEmpty(this.station_guide)) {
        this.$message.warning("请输入站点引导！");
        return;
      } else if (isEmpty(this.park_num)) {
        this.$message.warning("请输入车位数量！");
        return;
      }

      let action = "";
      if (this.num == 1) {
        action = "addStation";
      } else if (this.num == 2) {
        action = "editStation";
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: action,
        station_id: this.stationNumber,
        station_name: this.nameOfStation,
        station_type: this.stationType,
        operation_mode: this.operationModeName,
        enterprise_id: this.affiliatedEnterprises,
        address: this.address,
        longitude: this.longitude,
        latitude: this.latitude,
        province: this.provinceNameTem,
        city: this.cityNameTem,
        zone1: this.areaNameTem,
        zone2: this.street,
        start_time: this.startTime,
        end_time: this.endTime,
        visibility: this.visibility,
        operator_id: this.operator_id,

        area_code: this.area_code,
        equipment_own_id: this.equipment_own_id,
        county_code: this.county_code,
        station_phone: this.station_phone,
        service_phone: this.service_phone,
        station_status: this.stationStatus,
        park_num: this.park_num,
        car_match: this.car_match,
        station_guide: this.station_guide,
        station_around: this.station_around,
        park_info: this.park_info,
        // electric_fee:this.electric_fee,
        // service_fee:this.service_fee,
        park_fee: this.park_fee,
        payment: this.payment,
        support_order: this.support_order,
        remark: this.remark,
        parkingLotNumber: this.parkingLotNumber,
        abilityCode: this.abilityCode,
        station_use_type: this.station_use_type,
        parking_app_id: this.parking_app_id,
        parking_app_secret: this.parking_app_secret,
        discountMerchantName: this.discountMerchantName,
        cid: this.cid,
        discountName: this.discountName,
        discountTemplateCode: this.discountTemplateCode,
        discountMethod: this.discountMethod,
        discountDuration: this.discountDuration,
        discountAmount: this.discountAmount,
        discountRate: this.discountRate
      };

      if (this.num == 2) {
        params.station_id = this.editStationId;
      }
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.newStationDialog = false;
            if (this.num == 1) {
              this.getDataList();
              this.provincesName = "";
              this.cityName = "";
              this.cityList = [];
            } else if (this.num == 2) {
              this.getDataList(this.provincesName, this.cityName);
            }

            this.$message.success(su.data.message);
            this.nameOfStation = "";
            this.stationNumber = "";
            this.affiliatedEnterprises = "";
            this.stationType = "";
            this.operationModeName = "";
            this.visibility = "";
            this.cityNameTem = "";
            this.provinceNameTem = "";
            this.areaNameTem = "";
            this.street = "";
            this.address = "";
            this.latitude = "";
            this.longitude = "";
            this.startTime = "";
            this.endTime = "";
            this.editStationId = "";
            this.disabled = false;
            this.detailsDisabeld = false;

            this.area_code = "";
            this.station_use_type = "";
            this.stationStatus = "";
            this.station_around = "";
            this.support_order = "";
            this.equipment_own_id = "";
            this.county_code = "";
            this.station_phone = "";
            this.service_phone = "";
            this.park_num = "";
            this.car_match = "";
            this.station_guide = "";
            this.park_info = "";
            // this.electric_fee = "";
            // this.service_fee = "";
            this.park_fee = "";
            this.payment = "";
            this.remark = "";
            this.parkingLotNumber = "";
            this.abilityCode = "";
            this.parking_app_id = "";
            this.parking_app_secret = "";
            this.discountMerchantName = "";
            this.cid = "";
            this.discountName = "";
            this.discountTemplateCode = "";
            this.discountMethod = "";
            this.discountDuration = "";
            this.discountAmount = "";
            this.discountRate = "";

          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    deleteClick(row) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "deleteStation",
        station_id: row.station_id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "",
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/DeviceManage/index",
            data: params,
            transformRequest: [
              (data) => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              },
            ],
          })
            .then((su) => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.getDataList(this.provincesName, this.cityName);
                this.getProvinces();
                // this.cityList = [];
                // this.cityName = "";
                // this.provincesName = "";
                // this.stationName = "";
                this.stationList = [];
              } else if (su.data.code == 300) {
                localStorage.clear();
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900) {
              } else {
                this.$message.error(su.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    getImg(row) {
      this.imgStationId = row.station_id;
      this.imgList = [];
      this.fileName = "";
      this.resData = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "uploadStationPictureUrl",
        station_id: this.imgStationId,
      };
      const formData = new FormData();
      Object.keys(this.resData).forEach((ele) => {
        formData.append(ele, this.resData[ele]);
      });
      // console.log(formData);
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getStationPictureUrls",
        station_id: row.station_id,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.imgList = su.data.list;
            this.imgDialog = true;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    dataURLtoBlob(base64) {
      // var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      // bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      // while(n--){
      //     u8arr[n] = bstr.charCodeAt(n);
      // }
      // return new Blob([u8arr], {type:mime});
      let len = base64.length * 0.75; // 转换为int8array所需长度
      base64 = base64.replace(/=*$/, ""); // 去掉=号（占位的）

      const int8 = new Int8Array(len); //设置int8array视图
      let arr1,
        arr2,
        arr3,
        arr4,
        p = 0;

      for (let i = 0; i < base64.length; i += 4) {
        arr1 = this.map[base64[i]]; // 每次循环 都将base644个字节转换为3个int8array直接
        arr2 = this.map[base64[i + 1]];
        arr3 = this.map[base64[i + 2]];
        arr4 = this.map[base64[i + 3]];
        // 假设数据arr 数据 00101011 00101111 00110011 00110001
        int8[p++] = (arr1 << 2) | (arr2 >> 4);
        // 上面的操作 arr1向左边移动2位 变为10101100
        // arr2 向右移动4位：00000010
        // | 为'与'操作: 10101110
        int8[p++] = (arr2 << 4) | (arr3 >> 2);
        int8[p++] = (arr3 << 6) | arr4;
      }
      return int8;
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    imgBroadcastChange(file, fileList) {
      // debugger
      this.file = file.raw;
      this.fileName = file.name;
    },
    uploadSuccess(res, file) {},
    startUpload() {
      this.resData = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "uploadStationPictureUrl",
        station_id: this.imgStationId,
      };
      const formData = new FormData();
      formData.append("uid", this.resData.uid);
      formData.append("token", this.resData.token);
      formData.append("action", this.resData.action);
      formData.append("station_id", this.resData.station_id);
      formData.append("file", this.file);
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: formData,
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.$message.success("上传成功");
            this.imgList.push(su.data.picture_url);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    deleteImg(url) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "deleteStationPictureUrl",
        station_id: this.imgStationId,
        picture_url: url,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            for (let i in this.imgList) {
              if (this.imgList[i] == url) {
                //   this.imgList = this.imgList.slice(i,1);
                this.imgList.splice(i, 1); //从i位置开始删除1个数字
                // console.log(this.imgList);
                // i = i-1;
              }
            }
            this.$message.success(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="scss">
.station-list {
  .station-list-top {
    width: 98%;
    height: 60px;
    margin-left: 1%;
    margin-top: 16px;
    background-color: #ffffff;
    text-align: left;
    span {
      line-height: 60px;
      font-size: 16px;
      color: #0076bc;
      margin-left: 20px;
      font-weight: 700;
    }
    .station-select {
      float: right;
      margin-top: 10px;
      margin-right: 20px;
    }
  }
  .station-list-table {
    width: 98%;
    margin-top: 12px;
    background-color: #ffffff;
    margin-left: 1%;
    .station-list-button {
      width: 98%;
      margin-left: 1%;
      height: 60px;
      .el-button {
        float: left;
        margin-top: 20px;
        background-color: #0177bd;
        color: #ffffff;
        border: none;
      }
      .el-button.active {
        background-color: #a5a5a5;
      }
    }
    .table-list {
      width: 98%;
      margin-top: 20px;
      margin-left: 1%;
      .btn {
        width: 52px;
        height: 26px;
        background-color: #0071bd;
        border: none;
        color: #fffeff;
        padding: 0 !important;
        font-size: 12px;
      }
      .delete {
        background-color: #02b271;
      }
      .img {
        background-color: #f05502;
      }
      .edit.active {
        background-color: #a5a5a5;
      }
      .details {
        background-color: rgb(165, 2, 240);
      }
      .delete.active {
        background-color: #a5a5a5;
      }
      .img.active {
        background-color: #a5a5a5;
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-top: 20px;
      margin-right: 18px;
    }
  }
  .new-station-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .new-station-parameter {
      width: 100%;
      .parameter {
        width: 70%;
        margin-left: 15%;
        margin-bottom: 16px;
        .star {
          color: #ea0000;
        }
        .tool-tip {
          margin-left: 10px;
          background-color: #0071bd;
          color: #ffffff;
          font-size: 22px;
          display: inline-block;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          text-align: center;
        }
        .ml-13 {
          margin-left: 13px;
        }
        .ml-24 {
          margin-left: 24px;
        }
        .ml-40 {
          margin-left: 40px;
        }
        .el-input,
        .el-select {
          width: 80%;
        }
      }
      .parameter-city {
        .el-input,
        .el-select {
          width: 40%;
        }
      }
      .parameter-btn {
        margin-top: 40px;
        .cancel {
          width: 25%;
          background-color: #0071bd;
          color: #ffffff;
          border: none;
          height: 50px;
        }
        .confirm {
          width: 25%;
          background-color: #02b36f;
          color: #ffffff;
          border: none;
          height: 50px;
        }
      }
    }
  }
  .select-img-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .img-box {
      width: 100%;
      .img-list {
        width: 70%;
        min-height: 354px;
        margin-left: 15%;
        border: 1px solid #dbdbdb;
        border-radius: 6px;
        .img {
          width: 28%;
          height: 190px;
          border: 1px solid #dbdbdb;
          float: left;
          margin-left: 2.5%;
          margin-right: 2%;
          margin-bottom: 10px;
          position: relative;
          img {
            width: 100%;
            height: 156px;
          }
          div {
            text-align: left;
            position: absolute;
            bottom: 6px;
            width: 100%;
            span {
              display: inline-block;
              width: 110px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            i {
              cursor: pointer;
              float: right;
              width: 20px;
              height: 20px;
              background: url(../../assets/img/icon.png) -140px 0px no-repeat;
              // background-color: #ccc;
              margin-right: 10px;
              // background-size: 100% 100%;
            }
          }
        }
      }
      .upload-btn {
        width: 70%;
        margin-left: 15%;
        margin-top: 20px;
        .upload-left {
          width: 440px;
          height: 60px;
          float: left;
          input {
            width: 336px;
            height: 40px;
            border: 1px solid #dbdbdb;
            border-top-left-radius: 6px;
            border-bottom-left-radius: 6px;
            float: left;
            padding-left: 10px;
          }
          .file-btn {
            float: right;
            width: 91px;
            height: 42px;
            background-color: #0071bd;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            border-top-right-radius: 6px;
            border-bottom-right-radius: 6px;
            border: 1px solid #0071bd;
            vertical-align: top;
            cursor: pointer;
            .file-icon {
              display: inline-block;
              vertical-align: top;
              width: 29px;
              height: 25px;
              background: url(../../assets/img/icon.png) -137px -45px no-repeat;
              margin-top: -2px;
            }
          }
        }
        .upload-rig {
          float: right;
          .el-button {
            background-color: #ea0001;
            border: none;
            color: #ffffff;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1386px) {
  .station-list {
    // padding-right: 5%;
  }
  .station-list.active {
    // padding-right: 14%;
  }
}
@media screen and (max-width: 1260px) {
  .station-list {
    // padding-right: 5%;
  }
}
</style>
<style lang="scss">
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #0177bd !important;
  color: #ffffff;
}
.station-list {
  .el-table td,
  .el-table th {
    padding: 6px 0 !important;
  }
}
.station-list .el-table--enable-row-hover .el-table__body tr:hover > td .edit {
  background-color: #409eff;
}
.station-list .el-input.is-disabled .el-input__inner {
  background-color: #ffffff;
  color: #606266;
}
</style>


// WEBPACK FOOTER //
// src/components/stationManagement/stationList.vue